<div class="wizard-summary">
  <div
    class="wizard-summary-pending-banner"
    *ngIf="pendingHardStopNames.length || pendingRequiredNames.length">
    <svg-icon
      src="/assets/icon/icon-warning-circle-sm.svg"
      class="icon s-16 wizard-summary-pending-banner-icon"
      aria-label="Warning"></svg-icon>
    <div class="wizard-summary-pending-banner-text">
      <p class="wizard-summary-pending-banner-title">
        This behavior stays Draft until the following sections are completed.
      </p>
      <p
        class="wizard-summary-pending-banner-line"
        *ngIf="pendingHardStopNames.length">
        <strong>Hard Stop:</strong> {{ pendingHardStopNames.join(', ') }}
      </p>
      <p
        class="wizard-summary-pending-banner-line"
        *ngIf="pendingRequiredNames.length">
        <strong>Required:</strong> {{ pendingRequiredNames.join(', ') }}
      </p>
    </div>
  </div>

  <div
    class="wizard-summary-section"
    *ngFor="
      let section of sections;
      let isLast = last;
      trackBy: trackBySection
    ">
    <div class="section-header">
      <div class="section-header-content">
        <span class="step-badge"
          >{{ section.stepNumber }}/{{ section.totalSteps }}</span
        >
        <h3 class="section-title">{{ section.title }}</h3>
        <span
          class="wizard-summary-badge wizard-summary-badge--hard-stop"
          nz-tooltip
          nzTooltipTitle="User cannot proceed to the next step until this is filled"
          *ngIf="section.isHardStop">
          Hard Stop
        </span>
        <span
          class="wizard-summary-badge wizard-summary-badge--required"
          nz-tooltip
          nzTooltipTitle="Must be filled before the plan can be completed"
          *ngIf="!section.isHardStop && section.isRequired">
          Required
        </span>
        <span
          class="error-text wizard-summary-pending-text"
          *ngIf="
            section.pendingHardStopNames?.length ||
            section.pendingRequiredNames?.length
          ">
          Incomplete
        </span>
        <button
          *ngIf="canEditSection(section)"
          type="button"
          class="icon-button no-external-text"
          [title]="'Edit ' + section.title"
          [attr.aria-label]="'Edit ' + section.title"
          (click)="onEdit(section)">
          <svg-icon
            src="/assets/icon/icon-edit.svg"
            class="icon s-18 redirect no-external-text"
            aria-label="Edit"></svg-icon>
        </button>
      </div>
    </div>

    <div class="section-divider"></div>
    <div class="section-content">
      <div
        class="content-items"
        *ngIf="section.content.items && section.content.items.length">
        <p class="item-text" *ngFor="let item of section.content.items">
          {{ item }}
        </p>
      </div>

      <div
        class="badge-list"
        *ngIf="section.content.badges && section.content.badges.length">
        <span
          class="success-badge"
          *ngFor="let badge of section.content.badges">
          {{ badge }}
        </span>
      </div>

      <div class="description-group" *ngIf="section.content.description">
        <label
          class="field-label"
          for="wizard-summary-description-{{ section.stepIndex }}"
          >Operational Definition</label
        >
        <div class="field-content">
          <p
            class="field-text"
            id="wizard-summary-description-{{ section.stepIndex }}">
            {{ section.content.description }}
          </p>
        </div>
      </div>

      <div
        class="fields-wrapper"
        *ngIf="section.content.fields && section.content.fields.length">
        <div
          class="field-group"
          *ngFor="let field of section.content.fields; let i = index">
          <label
            class="field-label"
            [attr.for]="'wizard-summary-field-' + section.stepIndex + '-' + i"
            >{{ field.label }}</label
          >
          <div class="field-content">
            <p
              class="field-text"
              [id]="'wizard-summary-field-' + section.stepIndex + '-' + i">
              {{ field.value }}
            </p>
          </div>
        </div>
      </div>

      <div
        class="checkbox-list"
        *ngIf="
          section.content.checkboxes && section.content.checkboxes.length;
          else noCheckboxes
        ">
        <div
          class="checkbox-item"
          *ngFor="let checkbox of section.content.checkboxes">
          <svg-icon
            src="/assets/icon/icon-checkbox-preview.svg"
            class="checkbox-icon"
            aria-label="Checkbox Preview"></svg-icon>
          <span class="checkbox-label">{{ checkbox.label }}</span>
        </div>
      </div>
      <ng-template #noCheckboxes>
        <span
          *ngIf="
            section.content.checkboxes &&
            (!section.content.otherDescription ||
              !section.content.otherDescription.length)
          ">
          Nothing entered
        </span>
      </ng-template>
    </div>

    <div
      *ngIf="section.content.questions && section.content.questions.length"
      class="questions-section">
      <div
        class="question-group"
        *ngFor="let question of section.content.questions">
        <div class="question-label">{{ question.label }}</div>
        <div class="question-answer">{{ question.value }}</div>
      </div>
    </div>

    <div
      class="other-description"
      *ngIf="
        section.content.otherDescription &&
        section.content.otherDescription.length
      ">
      <div class="section-divider"></div>
      <div class="description-group">
        <label
          class="field-label"
          [attr.for]="'wizard-summary-other-' + section.stepIndex + '-0'"
          >Other Description</label
        >
        <div class="field-content">
          <p
            class="field-text"
            [id]="'wizard-summary-other-' + section.stepIndex + '-' + i"
            *ngFor="
              let desc of section.content.otherDescription;
              let i = index
            ">
            {{ desc }}
          </p>
        </div>
      </div>
    </div>

    <div class="section-separator" *ngIf="!isLast"></div>
  </div>
</div>
